export const GENERIC_SWAP_ABI = [
    {
        inputs: [
            { internalType: 'address', name: '_uniswapPermit2', type: 'address' },
            { internalType: 'address', name: '_allowanceTarget', type: 'address' },
        ],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    { inputs: [], name: 'AlreadyFilled', type: 'error' },
    { inputs: [], name: 'InsufficientOutput', type: 'error' },
    { inputs: [], name: 'InvalidMsgValue', type: 'error' },
    { inputs: [], name: 'InvalidSignature', type: 'error' },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'swapHash',
                type: 'bytes32',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'maker',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'taker',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'recipient',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'inputToken',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'inputAmount',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'outputToken',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'outputAmount',
                type: 'uint256',
            },
        ],
        name: 'Swap',
        type: 'event',
    },
    {
        inputs: [],
        name: 'EIP191_HEADER',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'EIP712_DOMAIN_NAME',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'EIP712_DOMAIN_SEPARATOR',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'EIP712_DOMAIN_VERSION',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'allowanceTarget',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'originalChainId',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                components: [
                    { internalType: 'address payable', name: 'maker', type: 'address' },
                    { internalType: 'address', name: 'takerToken', type: 'address' },
                    {
                        internalType: 'uint256',
                        name: 'takerTokenAmount',
                        type: 'uint256',
                    },
                    { internalType: 'address', name: 'makerToken', type: 'address' },
                    {
                        internalType: 'uint256',
                        name: 'makerTokenAmount',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'minMakerTokenAmount',
                        type: 'uint256',
                    },
                    { internalType: 'uint256', name: 'expiry', type: 'uint256' },
                    { internalType: 'uint256', name: 'salt', type: 'uint256' },
                    {
                        internalType: 'address payable',
                        name: 'recipient',
                        type: 'address',
                    },
                    { internalType: 'bytes', name: 'strategyData', type: 'bytes' },
                ],
                internalType: 'struct GenericSwapData',
                name: 'swapData',
                type: 'tuple',
            },
            { internalType: 'bytes', name: 'takerTokenPermit', type: 'bytes' },
        ],
        name: 'executeSwap',
        outputs: [
            { internalType: 'uint256', name: 'returnAmount', type: 'uint256' },
        ],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                components: [
                    { internalType: 'address payable', name: 'maker', type: 'address' },
                    { internalType: 'address', name: 'takerToken', type: 'address' },
                    {
                        internalType: 'uint256',
                        name: 'takerTokenAmount',
                        type: 'uint256',
                    },
                    { internalType: 'address', name: 'makerToken', type: 'address' },
                    {
                        internalType: 'uint256',
                        name: 'makerTokenAmount',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'minMakerTokenAmount',
                        type: 'uint256',
                    },
                    { internalType: 'uint256', name: 'expiry', type: 'uint256' },
                    { internalType: 'uint256', name: 'salt', type: 'uint256' },
                    {
                        internalType: 'address payable',
                        name: 'recipient',
                        type: 'address',
                    },
                    { internalType: 'bytes', name: 'strategyData', type: 'bytes' },
                ],
                internalType: 'struct GenericSwapData',
                name: 'swapData',
                type: 'tuple',
            },
            { internalType: 'bytes', name: 'takerTokenPermit', type: 'bytes' },
            { internalType: 'address', name: 'taker', type: 'address' },
            { internalType: 'bytes', name: 'takerSig', type: 'bytes' },
        ],
        name: 'executeSwap',
        outputs: [
            { internalType: 'uint256', name: 'returnAmount', type: 'uint256' },
        ],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'originalEIP712DomainSeparator',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'permit2',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    { stateMutability: 'payable', type: 'receive' },
];
//# sourceMappingURL=genericSwap.js.map